module.exports = __webpack_public_path__ + "static/media/wholesome.ca7e1345.svg";